<template>


	<section class="section-top-border relative">
		<lingo_toolbar_light></lingo_toolbar_light>


		<v-layout column wrap class="" align-center>

			<v-flex xs12 sm4 class="my-5">
				<h1 class="font-weight-thin display-2">Privacy Policy</h1>
			</v-flex>

			<v-flex xs12 class="my-55">
				<v-container grid-list-xl>
					<v-layout row wrap align-center>

						<v-card class="elevation-0" width="900">
							<v-card-title class=" top-border-thin-1 mb-3">



								<div class="card card-emphasised pt-4 pl-4 pr-3 px-20 subheading">
									<h2 id="introduction" class="blue--text font-weight-light">Introduction</h2>
									<p>We are Lingo AV Limited, a provider of text-to-speech
										services based in Bulgaria. Our company number is XXXX and our
										registered office is at XXX. All references in this policy to
										"Lingo AV", "our", "us" or "we" refer to Lingo AV Limited, or
										our suppliers which provide services to us, as appropriate.
									</p>

									<p>
										This Privacy Policy lets you know what happens to any personal
										data that you give to us or that we collect from you. We
										collect only the minimum amount of personal information
										necessary for you to make use of our Services; we ensure that
										we meet our responsibilities under the General Data Protection
										Regulation (GDPR); and we will only ever use your data as this
										Privacy Policy describes. We are registered with the
										<a href="https://ico.org.uk/">UK Information Commissioner's Office (ICO)??????</a>
										in the
										<a
											href="https://ico.org.uk/about-the-ico/what-we-do/register-of-data-controllers/">Register of Data Controllers</a>
										(registration number Z1127652).
									</p>

									<h2 class="blue--text font-weight-light">Applicability of This Privacy Policy</h2>
									<p>
										This Privacy Policy applies to Lingo AV's website at
										www.lingoav.com (the "
										<strong>website</strong>
										"), our web application available on the website (the "
										<strong>Services</strong>
										") and other interactions (e.g. customer service inquiries,
										live chat etc.) you may have with Lingo AV.
									</p>

									<p>This Privacy Policy does not apply to any third party
										applications or software that integrate with the Services, or
										any other third party products, services or businesses, where
										we are not the controller of your personal data.</p>

									<p>
										This Privacy Policy is separate to our
										<router-link to="/terms" >Terms of Service</router-link>
										, which set out the legal terms governing delivery, access and
										use of the Services (the "
										<strong>Terms of Service</strong>
										").
									</p>

									<h2 id="how-we-handle-your-data" class="blue--text font-weight-light">
										<a name="1"></a>
										1. How We Handle Your Data
									</h2>
									<h3>
										<a name="1.1"></a>
										1.1 Information We Collect
									</h3>
									<h4>Information from website browsers</h4>
									<h5>What do we collect?</h5>
									<p>
										If you are browsing the website, we collect the same basic
										information that many other websites collect. We use common
										Internet technologies, such as cookies and web server logs.
										This is information we collect from everybody who visits our
										website, whether they have an account or not. More information
										on cookies may be found
										<router-link to="/cookiePolicy" >here</router-link>
										.
									</p>
									<p>The information we collect about all visitors to our website
										includes the visitor's browser type ("User Agent"), language
										preference, referring site, and the date and time of each
										visitor request. We also collect potentially
										personally-identifying information like Internet Protocol (IP)
										addresses.</p>

									<h4>Information from users converting files</h4>
									<h5>What do we collect?</h5>
									<p>
										If you convert a file using our services we may collect your
										email address along with details of the
										filename or file URL.
									</p>

									<h5>Why do we collect this?</h5>
									<p>
										We collect this information in order to provide our file
										conversion services to you. Without this information we are
										not able to generate your files or provide you with a link to
										download your converted files.
									</p>

									<h4>People who contact us with enquiries</h4>
									<h5>What do we collect?</h5>
									<p>
										If you contact us with an enquiry, we will collect the
										information provided when you correspond with us, such as your
										name, your address, your email address and your telephone
										number.
									</p>

									<h5>Why do we collect this?</h5>
									<p>
										We will collect, use and store the personal information listed
										above to deal with any enquiries or issues you have about our
										Services, including any questions you may have about how we
										collect, store and use your personal information, or any
										requests made by you for a copy of the information we hold
										about you.
									</p>


									<h3>
										<a name="1.2"></a>
										1.2 Information We Do Not Collect
									</h3>
									<p>
										We do not intentionally collect or store special categories of
										personal data, such as genetic data, health information, or
										religious information. Although Lingo AV does not request or
										intentionally collect any special categories of personal data,
										we realize that you might store this kind of information in
										your account, via the files that you generate.
									</p>

									<h3>
										<a name="1.3"></a>
										1.3 How We Use Your Information and our Legal Basis for doing
										so
									</h3>
									<p>
										We use the information you provide to us in a number of ways and
										we have set out our legal basis for processing your
										information below:
									</p>

									<h4>To provide, update and maintain the Services we offer to
										you</h4>
									<p>
										This is the most common usage of your information. We use your
										personal information to provide various audio/video generation
										Services to you, in accordance with our Terms of Service. In
										particular, we will use your data to: set-up an account;
										generate the files that you provide us with into different
										formats; and if you provide us with an email address, send you
										links to download those files to that email address.
									</p>
									<p>Our use of your personal information in this way is
										necessary to perform our obligations to provide the Services
										to you, under our Terms of Service.</p>

									<h4>To communicate with you by responding to your requests,
										comments and questions</h4>
									<p>
										If you contact our support team we may use the information that
										you provide to us in order to help us respond to your enquiry.
									</p>
									<p>Our use of your personal information in this way is
										necessary to perform our customer service obligations to you,
										under our Terms of Service.</p>
									<p>If we do not have a contract with you, we may process your
										personal information for these purposes where it is in our
										legitimate interests to do so for customer services purposes.
									</p>

									<h4>For billing, account management and other administrative
										matters</h4>
									<p>
										Lingo AV may need to contact you for invoicing, account management
										and similar reasons and we use account data to administer
										accounts and keep track of billing and payments.
									</p>
									<p>Our use of your personal information in this way is
										necessary to perform our obligations to you under our Terms of
										Service.</p>

									<h4>As required by applicable law, legal process or regulation
									</h4>
									<p>
										We may use your information to comply with court orders and
										similar legal or regulatory obligations which apply to us.
									</p>
									<p>This may include where we reasonably consider it is in our
										legitimate interests or the legitimate interests of others to
										comply, as well as where we are legally required to do so.</p>

									<h4>To investigate and help prevent abuse or security issues
									</h4>
									<p>
										We may use information such as your IP address to help us
										prevent abuse of the Services we provide and investigate any
										potential unauthorized use of those Services or other security
										breaches.
									</p>
									<p>In these circumstances, we believe we have a legitimate
										interest in handling your data, and do not believe that this
										storage and use of your data will be of particular concern to
										you.</p>
									<p>We also collect and use data which is aggregated or
										anonymised for certain business purposes, such as creating
										aggregate statistics or reporting. However, no single
										individual will be identifiable from the anonymised details we
										collect for these purposes.</p>


									<h2 id="how-we-share-data" class="blue--text font-weight-light">
										<a name="2"></a>
										2. How We Share Data
									</h2>
									<h3>
										<a name="2.1"></a>
										2.1 Sharing Your Information
									</h3>
									<p>
										We
										<strong>do not</strong>
										share, sell, rent or trade your email address with any third
										parties for any commercial purposes.
									</p>
									<p>We may share personal information with a limited number of
										third-party vendors who process it on our behalf to provide or
										improve our Services, and who have agreed to privacy
										restrictions and security obligations consistent with this
										Privacy Policy.</p>
									<p>We will share your personal information with the following
										third party vendors:</p>
									<ul>
										<li>Amazon Web Services, Inc who provides server hosting and
											content distribution networks (CDN's) services;</li>
										<li>PayPal (Europe) S. r.l. et Cie, S.C.A. who provides
											payment processing services; and</li>
										<li>Google LLC, WeTransfer B.V., Habla, Inc and Slack
											Technologies Inc, who provide customer support tooling
											services.</li>
									</ul>
									<p>When we transfer your data to our vendors, we remain
										responsible for it. We try to ensure that any third parties
										with whom we share your personal information are limited (by
										law and by contract) in their ability to use your personal
										information for any purpose other than to provide services for
										us.</p>
									<p>We may share personal information where it is in our
										legitimate interests to do so to run, grow and develop our
										business if we are involved in a merger, sale, or acquisition.
										If any such change of ownership happens, we will ensure it is
										under terms that preserve the confidentiality of personal
										information, and we will notify you on our website or by email
										before any transfer of your personal information.</p>

									<h3>
										<a name="2.2"></a>
										2.2 Third Party Advertising
									</h3>
									<p>We may host third party advertising at Lingo AV.com. When we
										do we take measures to limit the amount of data that is shared
										with these parties, and use extra protections for customers
										using our Services from within the European Economic Area
										(EEA).</p>
									<p>If you are using our Services when not logged-in via a user
										account, or if you are logged-in with a "Basic" account we run
										advertisements provided by third parties for products and
										services that may be of interest to you. The advertising that
										we run differs depending on where you are accessing our
										Services from.</p>

									<h4>If you access our Services outside the European Economic
										Area (EEA)</h4>
									<p>
										We run third party advertisements using a variety of partner
										services. We only work with partners committed to providing
										strong protections for your personal data. In the course of
										providing these advertisements our partners may: (i) collect
										information directly from your device, such as your IP
										address, device ID, advertising ID, and information about your
										browser or operating system; (ii) combine information about
										you received from Lingo AV with information about you from
										other sites or services; and (iii) place or recognize a unique
										cookie on your browser (please see our "
										<router-link to="/cookiePolicy" >Cookies</router-link>
										" section for further details).
									</p>

									<h4>If you access our Services within the European Economic
										Area (EEA)</h4>
									<p>We run third party advertisements but specifically do not
										share any personal information with advertising providers in
										order to target or personalise those ads. When serving these
										ads no personal data, or information from past behaviour is
										used for demographic targeting or user list targeting
										purposes. These "Non-Personalised Ads" (NPA) are instead
										served based on contextual information, including coarse (e.g.
										city-level) geo-targeting based on current location, and
										content on the current webpage.</p>
									<p>
										Although non-personalized ads don't use cookies or mobile ad
										identifiers for ad targeting purposes, they do still use
										cookies or mobile ad identifiers for frequency capping,
										reporting, and to combat fraud and abuse (please see our "
										<router-link to="/cookiePolicy" >Cookies</router-link>
										" section for further details).
									</p>

									<h4>Opting out of personalised third party ads</h4>
									<ul>
										<li>
											You can opt-out of receiving marketing advertisements from
											third party advertisers and ad networks who are members of
											the Network Advertising Initiative or who follow the Digital
											Advertising Alliance's Self-Regulatory Principles for Online
											Behavioral Advertising by visiting the opt-out pages on their
											websites. We have included links here for your reference, but
											please check the organizations' respective sites for the
											latest information:
											<ul>
												<li>
													<a href="http://www.networkadvertising.org/choices">
														http://www.networkadvertising.org/choices
													</a>
												</li>
												<li>
													<a href="http://www.aboutads.info/choices">
														http://www.aboutads.info/choices
													</a>
												</li>
												<li>
													<a href="http://youradchoices.com">
														http://youradchoices.com
													</a>
												</li>
											</ul>
										</li>

										<li>On your iPhone, iPad or Android, you can change your
											device settings to control whether you see online
											interest-based ads.</li>

										<li>
											For advertisements provided by Google you can use Google's
											"Ads Settings" tool to manage the ads you see and to opt out
											of Ads Personalization (visit
											<a href="https://www.google.com/settings/ads/preferences">https://www.google.com/settings/ads/preferences</a>
											for further information). You can read more about Google's
											personalisation at
											<a href="https://policies.google.com/technologies/partner-sites">https://policies.google.com/technologies/partner-sites
											</a>
										</li>
									</ul>
									<p></p>

									<h3>
										<a name="2.3"></a>
										2.3 Legal Disclosures
									</h3>
									<p>Lingo AV may disclose personally-identifying information or
										other information we collect about you in response to a valid
										subpoena, court order, warrant, or similar government order,
										or when we believe in good faith that disclosure is reasonably
										necessary to protect our property or rights, or those of third
										parties or the public at large. This may include exchanging
										personal information with other organisations for the purposes
										of fraud protection and credit risk reduction.</p>
									<p>We will also disclose your personal information to third
										parties in order to enforce or apply our terms and conditions
										or any other agreement or to respond to any claims, to protect
										our rights or the rights of a third party, to protect the
										safety of any person or to prevent any illegal activity.</p>


									<h2 id="how-we-manage-data" class="blue--text font-weight-light">
										<a name="3"></a>
										3. How We Manage Data
									</h2>
									<h3>
										<a name="3.1"></a>
										3.1 Security
									</h3>
									<p>Lingo AV takes the security of data very seriously, and we
										work hard to protect any information you provide to us from
										loss, misuse, and unauthorized access or disclosure. We take
										all reasonable precautions to safeguard the confidentiality of
										your personal information, including through use of
										appropriate organisational and technical measures. These
										measures take into account the sensitivity of the data we
										collect, process and store, and the current state of
										technology.</p>
									<p>Given the nature of communications and information
										processing technology, Lingo AV cannot guarantee that
										information, during transmission through the Internet or while
										stored on our systems or otherwise in our care, will be
										absolutely safe from intrusion by others, but we do our utmost
										to protect it. Once we have received your personal
										information, we will use strict procedures and security
										features to prevent unauthorised access to it.</p>
									<p>As a minimum we take the following measures to secure your
										data:</p>
									<ul>
										<li>
											<strong>Physical Security</strong>
											- Lingo AV infrastructure is only hosted in data centres
											which meet rigorous security standards. Physical access is
											strictly controlled both at the perimeter and at building
											ingress points by professional security staff utilising video
											surveillance, intrusion detection systems, and other
											electronic means.
										</li>

										<li>
											<strong>Data Transfer Integrity</strong>
											- All traffic to and from Lingo AV servers is secured by
											transport level security (TLS) sent over a Secure Socket
											Layer (SSL), and secured using an AES 256-bit SSL
											certificate. This ensures that data sent between your systems
											and ours is encrypted using military grade encryption.
										</li>

										<li>
											<strong>Firewalls</strong>
											- Lingo AV enforces network level control for access to
											infrastructure by using multiple different firewall
											technologies to ensure that different components of its
											systems are logically isolated from one another.
										</li>

										<li>
											<strong>Software Updates</strong>
											- Lingo AV regularly applies software patches to production
											infrastructure in order to ensure a strong security posture
											to known software vulnerabilities.
										</li>

									</ul>

									<p></p>
									<h3>
										<a name="3.2"></a>
										3.2 Data Retention and Deletion
									</h3>
									<h4>If you have an account with Lingo AV</h4>
									<p>If you have an account with Lingo AV, we will retain your
										personal information for as long as your account is active or
										as needed to provide you with Services that you request (in
										accordance with our Terms of Service).</p>
									<p>Once your account is deactivated we will permanently remove
										any files associated with your account 35 days after
										deactivation.</p>
									<p>We may retain certain other personal information (such as
										your email address) for 18 months after your account is
										deactivated, unless you delete it or request its deletion. For
										example, we don't automatically delete inactive user accounts,
										so unless you ask us to permanently delete your account we
										will retain some account information to enable you to return
										and use our Services more easily in future.</p>

									<h4>If you do not have an account with Lingo AV</h4>
									<p>We will store any files you submit to us for conversion, and
										their converted outputs on our systems for no longer than 7
										days following receipt. After this time they are permanently
										removed from our storage systems.</p>
									<p>We will retain personal information such as your IP address,
										email address (if provided by you) and browser details for no
										longer than 30 days. After this time we permanently delete
										your browser data and anonymise your IP address and email
										address (if provided by you) so that we can no longer
										personally identify you.</p>


									<h3>
										<a name="3.3"></a>
										3.3 International Data Transfers
									</h3>
									<p>Lingo AV may transfer your personal data to countries other
										than the one in which you live, including to our file server
										suppliers located in the United States.</p>
									<p>If we provide any personal information about you to any such
										non-EEA entities, we will take appropriate measures to ensure
										that the recipient protects your personal information
										adequately in accordance with this privacy policy. These
										measures may include the following permitted in Articles 45
										and 46 of the GDPR:</p>
									<ul>
										<li>
											in the case of US based entities, entering into European
											Commission approved standard contractual arrangements with
											them, or ensuring they have signed up to the EU-US Privacy
											Shield (see further
											<a href="https://www.privacyshield.gov/welcome">https://www.privacyshield.gov/welcome</a>
											); or
										</li>
										<li>in the case of entities based in other countries outside
											the EEA, entering into European Commission approved standard
											contractual arrangements with them.</li>
									</ul>
									<p>
										Further details on the steps we take to protect your personal
										information, in these cases is available from us on request by
										contacting us by email at
										<a href="mailto:info@Lingo AV.com">info@Lingo AV.com</a>
										at any time.
									</p>


									<h2 id="your-rights" class="blue--text font-weight-light">
										<a name="4"></a>
										4. Your Rights
									</h2>
									<p>
										If you have a user account for the Services you may review and
										edit any personal data you have supplied to us in your user
										profile. If you do not have a user account, or if you have
										questions about your account information or other personal
										data please contact us by email at
										<a href="mailto:info@Lingo AV.com">info@Lingo AV.com</a>
										.
									</p>
									<p>Individuals located in certain countries, including the
										European Economic Area and Switzerland, have certain statutory
										rights in relation to their personal data. While some of these
										rights apply generally, certain rights apply only in certain
										limited circumstances. We describe these rights below.</p>
									<p>Please note that we may ask you to verify your identity
										before taking further action on your request. Additionally
										your request and choices may be limited in certain cases: for
										example, if fulfilling your request would reveal information
										about another person, or if you ask to delete information
										which we are permitted by law or have compelling legitimate
										interests to keep.</p>

									<h3>
										<a name="4.1"></a>
										4.1 Right to be Informed
									</h3>
									<p>You have the right to be provided with information about the
										data we hold, our data processing activities and whether we
										transfer personal data outside of the EAA, along with the
										methods we use to safeguard such data.</p>

									<h3>
										<a name="4.2"></a>
										4.2 Right to Access
									</h3>
									<p>In some jurisdictions, applicable law may entitle you to
										request copies of your personal information held by us.</p>

									<h3>
										<a name="4.3"></a>
										4.3 Right to Rectification
									</h3>
									<p>You have the right to ask us to correct inaccurate, out of
										date or incomplete personal information concerning you (and
										which you cannot update yourself within the Services).</p>

									<h3>
										<a name="4.4"></a>
										4.4 Right to Erasure
									</h3>
									<p>We generally retain any personal information for as long as
										is necessary for the performance of the contract between you
										and us and to comply with our legal obligations. If you no
										longer want us to use your information to provide the Services
										to you, you can request that we erase your personal
										information and (if you have one) close your user account.
										Please note that if you request the erasure of your personal
										information:</p>
									<ul>
										<li>We may retain some of your personal information as
											necessary for our legitimate business interests, such as
											fraud.</li>
										<li>We may retain and use your personal information to the
											extent necessary to comply with our legal obligations.</li>
										<li>Because we maintain the Lingo AV Services to protect from
											accidental or malicious data loss and destruction, residual
											copies of your personal information may not be removed from
											our backup systems for a limited period of time.</li>
									</ul>

									<p></p>
									<h3>
										<a name="4.5"></a>
										4.5 Right to Object / Restrict Processing
									</h3>
									<p>In some jurisdictions, applicable law may entitle you to
										request Lingo AV not to process your personal information for
										certain specific purposes where such processing is based on
										our (or another party's) legitimate interests. If you object
										to such processing Lingo AV will no longer process your
										personal information for these purposes unless we can
										demonstrate compelling legitimate grounds for such processing
										or such processing is required for the establishment, exercise
										or defence of legal claims.</p>

									<h3>
										<a name="4.6"></a>
										4.6 Right to Data Portability
									</h3>
									<p>You may be entitled to request copies of personal
										information that you have provided to us in a structured,
										commonly used, and machine-readable format and/or request us
										to transmit this information to another service provider
										(where technically feasible). This right only applies where we
										use your personal information on the basis of your consent or
										performance of a contract; and where our use of your
										information is carried out by automated means.</p>

									<h3>
										<a name="4.7"></a>
										4.7 Lodging Complaints
									</h3>
									<p>Subject to applicable law, you also have the right to lodge
										a complaint with your local data protection authority or the
										UK Information Commissioner's Office, which is Lingo AV's lead
										supervisory authority in the European Union.</p>


									<h2 id="other-important-information" class="blue--text font-weight-light">
										<a name="5"></a>
										5. Other Important Information
									</h2>
																		<h3>
										<a name="5.1"></a>
										5.1 Data Protection Authority
									</h3>
									<p>If you are a resident of the European Economic Area and
										believe we are the controller of your personal data within the
										scope of the General Data Protection Regulation (GDPR), you
										may direct questions or complaints to our lead supervisory
										authority:</p>
									<p>
										UK Information Commissioner
										<br>
											Information Commissioner's Office
											<br>
												Wycliffe House
												<br>
													Water Lane
													<br>
														Wilmslow
														<br>
															Cheshire
															<br>
																SK9 5AF
																<br>
																	United Kingdom
																	<br>
																		<br>

																			Phone: +44 1625 545 745
																			<br>
																				Fax: +44 1625 524 510
																				<br>
																					Email:
																					<a href="mailto:casework@ico.org.uk">casework@ico.org.uk</a>
									</p>

									<h3>
										<a name="5.2"></a>
										5.2 Contacting Lingo AV
									</h3>
									<p>
										Please feel free to contact Lingo AV if you have any questions
										about this Privacy Policy or complaints about Lingo AV's
										practices relating to your personal information, or if you are
										seeking to exercise any of your rights described in this
										Privacy Policy. You may contact us at
										<a href="mailto:info@Lingo AV.com">info@Lingo AV.com</a>
										or at our mailing address below:
									</p>
									<p>
										Lingo AV Ltd Data Protection Representative
										<br>
											The Courtyard????
											<br>
												United Kingdom
									</p>
								</div>
















							</v-card-title>
						</v-card>

					</v-layout>
				</v-container>
			</v-flex>
		</v-layout>


		<lingo_footer_light class="mt-5"></lingo_footer_light>
	</section>







</template>

<script>
	import lingo_toolbar_light from './ToolbarLight';
	import lingo_footer_light from './FooterLight';

	export default {
	name: "privacyPolicy",
	data() {
	return {

	};
	},
	components: {
	lingo_toolbar_light,
	lingo_footer_light
	}
	};
</script>
